import { SubtractNRIColumns, TractNRI, TractNRIColumns } from './types';
import { FullNRITable } from 'components/nri-table/nri-table';

interface TractNRITableProps {
  tractNRIRows: TractNRI[];
  isLoading: boolean;
  selectedRow?: TractNRI;
  onRowSelected?: (row: TractNRI | null) => void;
}

const TRACT_COLUMNS: Array<TractNRIColumns> = [
  'crmTract',
  'crmTractTags',
  'crmAccount',
  'totalSlotNri',
  'totalSlotWi',
  'tractNetAcres',
  'netAcreageUnits',
  'tractGrossAcres',
  'surveyArea',
  'quarterCall',
  'instrumentType',
  'depthRange',
];

const SUBTRACT_COLUMNS: Array<SubtractNRIColumns> = [
  'crmSubtractId',
  'uat',
  'uatNri',
  'uatWi',
  'subtractNetAcres',
  'subtractGrossAcres',
  'quarterCall',
  'partTractFactor',
  'partTractAcres',
  'leaseRoyaltyRate',
  'leaseRoyaltyType',
  'ptfAdjustment',
  'unitCoverage',
  'uatCoverage',
  'focusMdac',
  'executive',
  'bonus',
  'delay',
  'royalty',
  'royaltyBurdens',
  'wi',
  'orri',
  'orriBurdens',
];

export const TractNRITable = ({
  tractNRIRows,
  isLoading,
  selectedRow,
  onRowSelected,
}: TractNRITableProps) => {
  return (
    <FullNRITable
      tractNRIRows={tractNRIRows}
      isLoading={isLoading}
      tableId="tract-rollup-table"
      tractNRIColumns={TRACT_COLUMNS}
      subtractNRIColumns={SUBTRACT_COLUMNS}
      selectedRow={selectedRow}
      onRowSelected={onRowSelected}
    />
  );
};
